import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const SkeletonWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.xl};
`;

const SkeletonBlock = styled.div<{ $width?: string; $height?: string; $mb?: string }>`
  width: ${({ $width }) => $width || '100%'};
  height: ${({ $height }) => $height || '16px'};
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.surfaceHover} 25%,
    ${({ theme }) => theme.colors.background} 50%,
    ${({ theme }) => theme.colors.surfaceHover} 75%
  );
  background-size: 800px 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  margin-bottom: ${({ $mb, theme }) => $mb || theme.spacing.md};
`;

const SkeletonRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
`;

const SkeletonCard = styled.div`
  flex: 1;
  border: ${({ theme }) => theme.borders.thin};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  padding: ${({ theme }) => theme.spacing.lg};
  background: ${({ theme }) => theme.colors.surface};
`;

/** Page-level skeleton for workspace, brand profile, generate pages */
export function PageSkeleton() {
  return (
    <SkeletonWrapper>
      <SkeletonBlock $width="40%" $height="32px" $mb="8px" />
      <SkeletonBlock $width="60%" $height="14px" $mb="32px" />
      <SkeletonRow>
        <SkeletonCard>
          <SkeletonBlock $width="50%" $height="20px" $mb="16px" />
          <SkeletonBlock $height="12px" $mb="8px" />
          <SkeletonBlock $width="80%" $height="12px" $mb="8px" />
          <SkeletonBlock $width="60%" $height="12px" />
        </SkeletonCard>
        <SkeletonCard>
          <SkeletonBlock $width="50%" $height="20px" $mb="16px" />
          <SkeletonBlock $height="12px" $mb="8px" />
          <SkeletonBlock $width="70%" $height="12px" $mb="8px" />
          <SkeletonBlock $width="90%" $height="12px" />
        </SkeletonCard>
      </SkeletonRow>
    </SkeletonWrapper>
  );
}